import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import RosterForm from '../components/forms/RosterForm';
import '../styles/EmployeeMaster.css';
import RosterTable from '../components/RosterTable';

const RosterEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route

  const [rosterData, setRosterData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Show modal only if URL starts with /sbu/edit
  const showModal = location.pathname.startsWith('/roster/edit');

  const handleCloseModal = () => {
    navigate('/roster'); // Go back to list
  };

  // ✅ Fetch SBU details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getShiftRosterById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setRosterData(data.data);
          } else {
            setRosterData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching Roster by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Roster Master</h2>
      </div>

      {/* Table of SBUs */}
      <RosterTable />

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Roster</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : rosterData ? (
            <RosterForm rosterId={id} initialData={rosterData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this SBU.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RosterEditModel;
